import sectionPurchaseIncentiveCss from '../css-snippets/section-purchase-incentive';

const html = `
<style>${sectionPurchaseIncentiveCss}</style>
<div
  class="purchase-incentive-wrapper"
  data-id="unique-id"
  data-content-position="center"
  data-sale-text-1-show="true"
  data-sale-text-2-show="true"
  data-guarantee-text-1-show="true"
  data-guarantee-text-2-show="true"
>
  <div
    class="purchase-incentive container"
    data-top-padding="true"
    data-bottom-padding="true"
  >
    <div class="wrap-sale">
      <div class="wrap-sale-item">
        <div class="dot"></div>
        <p>Sale: Live For 24 Hrs.</p>
      </div>
      <div class="wrap-sale-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="hourglass-icon"
        >
          <path d="M5 22h14" />
          <path d="M5 2h14" />
          <path
            d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"
          />
          <path
            d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"
          />
        </svg>
        <p>Stock: Only 7 Units Left!</p>
      </div>
    </div>

    <div class="wrap-order-now">
      <a
        href="#"
        class="btn-order-now"
        style="background-color: #5ca605; color: #ffffff"
      >
        Order Now & Save 50%
      </a>
    </div>

    <div class="wrap-guarantee">
      <div class="wrap-guarantee-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="circle-star-icon"
        >
          <path
            d="M11.051 7.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.867l-1.156-1.152a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z"
          />
          <circle cx="12" cy="12" r="10" />
        </svg>
        <p>180 Days Money Back Guarantee</p>
      </div>
      <div class="wrap-guarantee-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="truck-icon"
        >
          <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
          <path d="M15 18H9" />
          <path
            d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"
          />
          <circle cx="17" cy="18" r="2" />
          <circle cx="7" cy="18" r="2" />
        </svg>
        <p>Free Shipping For Bundle Orders</p>
      </div>
    </div>
  </div>
</div>
`;
export default html;
